import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ProjConstants } from 'src/app/utils/proj.constant';
import { UtilsService } from 'src/app/utils/utils.service';

import { BottomBarData, BOTTOMBARWINDSPEED, BOTTOMBARHUMIDITY, BOTTOMBARTEMPERATURE } from '../../constants/StockChart/stock-chart-configuartion';
import { UtilsSharedModule } from '../../utils/utils/utils.module';
import { ConstantsModule } from './../../constants/constants.module';

@Component({
  selector: 'app-actual-bottombar-data',
  templateUrl: './actual-bottombar-data.component.html',
  styleUrls: ['./actual-bottombar-data.component.scss']
})
export class ActualBottombarDataComponent implements OnInit, OnChanges, OnDestroy {
  showBottomBar: boolean;
  showThrobberbottomBar: boolean;
  urlParams: Object;
  showStockChart = false;
  latLongsubscription: any;

  stockChartConfig: any;
  stateUUID: any;

  constructor(
    public utilsShared: UtilsSharedModule,
    private utils: UtilsService,
    public constants: ConstantsModule,
    private route: ActivatedRoute
  ) { }

  @Input() apiParams: any;
  @Output() closePopUp = new EventEmitter<any>();

  ngOnInit() {
    this.showStockChart = false;
    this.stateUUID = ProjConstants.IDTOUUIDMAPPING[this.route.snapshot.paramMap.get('id')];
  }

  ngOnChanges() {
    this.showStockChart = false;
    this.utils.getQueryParams().subscribe( data => {
      if (data != null && data != undefined) {
        this.urlParams = data;
        if (this.urlParams['component'] == this.constants.COMPONENT.WINDSPEED) {
          this.stockChartConfig = JSON.parse(JSON.stringify(BOTTOMBARWINDSPEED));
        } else if (this.urlParams['component'] == this.constants.COMPONENT.TEMPERATURE) {
          this.stockChartConfig = JSON.parse(JSON.stringify(BOTTOMBARTEMPERATURE));
        } else if (this.urlParams['component'] == this.constants.COMPONENT.HUMIDITY) {
          this.stockChartConfig = JSON.parse(JSON.stringify(BOTTOMBARHUMIDITY));
        } else {
          this.stockChartConfig = JSON.parse(JSON.stringify(BottomBarData));
        }
        if (this.validateParams()) {
          setTimeout(() => {
            this.reArrangeStockChartPostParams();
            this.showStockChart = true;
          }, 100);
        }
      }
    }).unsubscribe();
  }

  ngOnDestroy() {
    this.latLongsubscription.unsubscribe();
  }

  validateParams() {
    const params = this.urlParams;
    if (params == undefined || params['sDate'] == undefined ||
      params['eDate'] == undefined || params['loctype'] == undefined ||
      params['src'] == undefined || params['locuuid'] == undefined) {
      console.log('Incorrect parameters in the url. Please correct to see table.');
      return false;
    }

    return true;
  }

  closeBottomBar() {
    // console.log("Hello");
    this.showBottomBar = !this.showBottomBar;
    this.showThrobberbottomBar = false;
    this.closePopUp.emit();
  }

  reArrangeStockChartPostParams() {
    let obj;
    this.latLongsubscription = this.utils.getLatLong().subscribe(value => {
      obj = value;
    });
    this.stockChartConfig.applicationConfig.actual.apiConfig.postData['eDate'] = this.urlParams['eDate'];
    this.stockChartConfig.applicationConfig.actual.apiConfig.postData['format'] = this.urlParams['format'];
    this.stockChartConfig.applicationConfig.actual.apiConfig.postData['sDate'] = this.urlParams['sDate'];
    this.stockChartConfig.applicationConfig.actual.apiConfig.postData['src'] = this.urlParams['src'];
    this.stockChartConfig.applicationConfig.actual.apiConfig.postData['lat'] = obj['latitude'];
    this.stockChartConfig.applicationConfig.actual.apiConfig.postData['lon'] = obj['longitude'];
    this.stockChartConfig.applicationConfig.actual.apiConfig.postData['summary'] = false;
    this.stockChartConfig.applicationConfig.actual.apiConfig.postData['view'] = this.urlParams['view'];
    this.stockChartConfig.applicationConfig.actual.apiConfig.postData['sUUID'] = this.urlParams['sUUID'];
    if (this.urlParams['component'] == this.constants.COMPONENT.TEMPERATURE || this.urlParams['component'] == this.constants.COMPONENT.HUMIDITY) {
      this.stockChartConfig.applicationConfig.actual.apiConfig.postData['pEUUID'] = this.stateUUID;
      this.stockChartConfig.applicationConfig.actual.apiConfig.postData['format'] = this.constants.DATE_FORMAT_NEW[this.urlParams['format']];
      // this.stockChartConfig.applicationConfig.temperature.apiConfig.postData['pUUID'] = this.urlParams['pUUID'];
      // this.stockChartConfig.applicationConfig.temperature.apiConfig.postData['pType'] = this.urlParams['pType'];
      // this.stockChartConfig.applicationConfig.temperature.apiConfig.postData['classification'] = ['ACTUAL', 'NORMAL'];
    }
  }

}
